import React from "react";
import firebase from "../firebase";

const Header = (props) => {
  const handleLogout = () => {
    firebase.auth().signOut();
    props.setSec({
      email: "",
      photoURL: "",
      sec: "",
    });
  };
  return (
    <div className="header">
      <img src="/gmn.png" alt="GMN" />

      <button className="logout" onClick={handleLogout}>
        Logout
      </button>
    </div>
  );
};

export default Header;
